import React from "react";

import "./tfss.scss";

function Tfss003(){


    return(
        <div className="cert">
            <img src={require("../images/tfss003.png")} alt="" />
            
        </div>
    )
}

export default Tfss003;